module.exports = __webpack_public_path__ + "img/12_DSC8058-min.21c10cbd.jpg";